import React from 'react';
import Loadable from 'react-loadable';
import hubConfig from '../../../../config/hubs';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../components/loading_spinner/loading_spinner')
);

let MICPageComponent = false;
let WCIPageComponent = false;
let DefaultHubPageComponent = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  MICPageComponent = require('./most_innovative_companies_hub_page').default;
  // eslint-disable-next-line global-require
  WCIPageComponent = require('./world_changing_ideas_hub_page').default;
  // eslint-disable-next-line global-require
  DefaultHubPageComponent = require('./default_hub_page').default;
}

export function micHubPage(store) {
  const routeConfig = {
    path: '/:tag(most-innovative-companies)',
    component() {
      if (MICPageComponent) {
        return <MICPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: MICPageComponent ? MICPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./most_innovative_companies_hub_page').then(resp => {
        MICPageComponent = resp.default;
        routeConfig.loadData = MICPageComponent.loadData(store);

        return MICPageComponent;
      });
    },
    chunk: 'micHubPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function wciHubPage(store) {
  const routeConfig = {
    path: '/:tag(world-changing-ideas)',
    component() {
      if (WCIPageComponent) {
        return <WCIPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: WCIPageComponent ? WCIPageComponent.loadData(store) : false,
    preloadChunk() {
      return import('./world_changing_ideas_hub_page').then(resp => {
        WCIPageComponent = resp.default;
        routeConfig.loadData = WCIPageComponent.loadData(store);

        return WCIPageComponent;
      });
    },
    chunk: 'wciHubPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}

export function defaultHubPage(store) {
  const routeConfig = {
    path: `/:tag(${Object.keys(hubConfig).join('|')})`,
    component() {
      if (DefaultHubPageComponent) {
        return <DefaultHubPageComponent />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    autoScrollOff: true,
    loadData: DefaultHubPageComponent
      ? DefaultHubPageComponent.loadData(store)
      : false,
    preloadChunk() {
      return import('./default_hub_page').then(resp => {
        DefaultHubPageComponent = resp.default;
        routeConfig.loadData = DefaultHubPageComponent.loadData(store);

        return DefaultHubPageComponent;
      });
    },
    chunk: 'micHubPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="post-page">
          <article className="post__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }
  });

  return routeConfig;
}
